// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  permissionFlags: null,
  loadProjectDetailCustomComponentPending: false,
  loadProjectDetailCustomComponentError: null,
  addCustomComponentConfigPending: false,
  addCustomComponentConfigError: null,
  loadCustomComponentConfigsPending: false,
  loadCustomComponentConfigsError: null,
  deleteCustomComponentConfigPending: false,
  deleteCustomComponentConfigError: null,
  updateCustomComponentConfigPending: false,
  updateCustomComponentConfigError: null,
  addCustomComponentCssCdnPending: false,
  addCustomComponentCssCdnError: null,
  deleteCustomComponentCssCdnPending: false,
  deleteCustomComponentCssCdnError: null,
  updateCustomComponentCssCdnPending: false,
  updateCustomComponentCssCdnError: null,
  addCustomComponentJsCdnPending: false,
  addCustomComponentJsCdnError: null,
  deleteCustomComponentJsCdnPending: false,
  deleteCustomComponentJsCdnError: null,
  updateCustomComponentJsCdnPending: false,
  updateCustomComponentJsCdnError: null,
  addCustomDataMappingPending: false,
  addCustomDataMappingError: null,
  loadCustomDataMappingPending: false,
  loadCustomDataMappingError: null,
  deleteCustomDataMappingPending: false,
  deleteCustomDataMappingError: null,
  updateCustomDataMappingPending: false,
  updateCustomDataMappingError: null,
  loadCustomComponentConfigPending: false,
  loadCustomComponentConfigError: null,
  cloneCustomComponentPending: false,
  cloneCustomComponentError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  cloneCustomDataMappingPending: false,
  cloneCustomDataMappingError: null,
  deleteCustomFunctionPending: false,
  deleteCustomFunctionError: null,
  customFunctions: [],
  loadCustomFunctionConfigPending: false,
  loadCustomFunctionConfigError: null,
  loadCustomFunctionDetailPending: false,
  loadCustomFunctionDetailError: null,
  updateCustomFunctionPending: false,
  updateCustomFunctionError: null,
  addCustomFunctionPending: false,
  addCustomFunctionError: null,
  customFunctionExecutionPending: false,
  customFunctionExecutionError: null,
  customFunctionLogsPending: false,
  customFunctionLogsError: null,
  cloneCustomFunctionPending: false,
  cloneCustomFunctionError: null,
  generateCustomComponentPending: false,
  generateCustomComponentError: null,
};

export default initialState;
